const mjmlTemplate = `<mjml>
  <mj-head>
    <mj-attributes>
      <mj-all font-family="Inter, Arial, sans-serif" color="#3b4c56" />
      <mj-text font-size="15px" line-height="1.6" padding="0" />
      <mj-section padding="0" />
      <mj-column padding="0" />
    </mj-attributes>
    <mj-preview>
      {{preheaderText}}
    </mj-preview>

    <!-- Fine-grain CSS to mirror your classes -->
    <mj-style inline="inline">
      .markdown p + p { margin-top: 10px; }
      .markdown ul, .markdown ol { margin: 10px 0; padding-left: 20px; }
      .markdown li + li { margin-top: 6px; }
      .markdown a { color: inherit; text-decoration: underline; }
      .markdown strong { font-weight: 600; }
      .markdown em { font-style: italic; }
      .legal a { color: inherit !important; text-decoration: underline; }
      .legal-links a { cursor: pointer; }
      .social-icon {
        width: 30px !important; height: 30px !important; border-radius: 30px !important;
        background-color: rgba(255,255,255,0.7); display: inline-block;
      }
      .footer-name-address { opacity: .8; font-size: 12px; }
      .footer-name-address p { font-size: 12px !important; margin: 0 0 4px 0; }
      .strong { font-weight: 600; }
      .em { font-style: italic; }
    </mj-style>
  </mj-head>
  <mj-body background-color="#EEF1F7" width="600px">
    <mj-wrapper border="1px solid #D7D8DF" padding="0">
      <!-- Header: 80px tall, 30px side padding, semi-transparent bg -->
      <mj-section background-color="{{headerBgColor}}" padding="0 30px" css-class="mjml-header">
        <mj-column>
          <!-- 15px top spacer + 50px logo + 15px bottom spacer = ~80px -->
          <mj-spacer height="15px" />
          <mj-image src="{{logoUrl}}" alt="Logo" align="left" padding="0" width="{{logoWidth}}" height="{{logoHeight}}" css-class="mjml-logo" />
          <mj-spacer height="15px" />
        </mj-column>
      </mj-section>

      <!-- Hero image with 28px bottom margin -->
      <mj-section padding="0" css-class="mjml-hero">
        <mj-column>
          <mj-image src="{{heroImgUrl}}" alt="Hero" padding="0 0 0 0" href="{{heroImageLinkUrl}}" />
        </mj-column>
      </mj-section>

      <!-- Email body: padding 0 30px -->
      <mj-section padding="30px 30px" css-class="mjml-body" background-color="#FFFFFF">
        <mj-column>
          <!-- h1 with 14px bottom margin, 20px font-size -->
          <mj-text css-class="display-title" padding="0 0 12px 0" font-size="20px" font-weight="600" color="#000000">
            {{emailTitle}}
          </mj-text>
          <mj-text css-class="markdown" padding="0" line-height="1.6" font-size="15px">
            <!-- bodyHtml -->
          </mj-text>
          <mj-spacer height="14px" />
          
          <!-- CTA: full width, light bg, 42px height, 14px top margin, 500 weight -->
          <mj-button
            href="{{ctaUrl}}"
            background-color="{{ctaBackgroundColor}}"
            color="{{ctaTextColor}}"
            font-weight="500"
            font-size="15px"
            width="100%"
            align="center"
            padding="0 0 0 0"
            inner-padding="0"
            border-radius="0"
            line-height="42px"
            css-class="mjml-cta"
            >
            {{ctaText}}
          </mj-button>
        </mj-column>
      </mj-section>

      <!-- Footer: 30px top margin simulated with spacer, divider = border-top -->

      <mj-section padding="0 30px 20px" css-class="mjml-footer" background-color="#FFFFFF">
        <mj-column>
          <mj-divider border-width="1px" border-color="rgba(0,0,0,0.1)" padding="0" />


      <mj-table align="center" padding="25px 0 10px 0">
        <tr>
          <td style="text-align: center;">
            <!-- socialMediaLinksHtml -->
          </td>
        </tr>
      </mj-table>

          <!-- Name & Address -->
          <mj-text css-class="footer-name-address" align="center">
            <p>{{hotelName}}</p>
            <p>{{hotelAddress}}</p>
            <p>{{hotelCityStateZip}}</p>
          </mj-text>

          <!-- Legal (12px, .6 opacity, centered with link “gap”) -->
          <mj-text align="center" font-size="12px" css-class="legal" padding="10px 0 0 0" color="#3b4c56">
            <div class="legal-links" style="opacity:.5;">
              <a style="text-decoration: none;" href="{{privacyPolicyUrl}}">Privacy</a>
              <span style="display:inline-block;width:10px;font-size:9px;">|</span>
              <a style="text-decoration: none;" href="{{termsUrl}}">Terms</a>
              <span style="display:inline-block;width:10px;font-size:9px;">|</span>
              <a style="text-decoration: none;" href="{{unsubscribeUrl}}">Unsubscribe</a>
            </div>
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`

export default mjmlTemplate
